import type { ReactNode } from 'react';
import { EnvBadge } from '../../shell/AppShell';

export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="wdc-auth">
      <div className="wdc-auth__card wd-elevated">
        <div className="wdc-brand">
          <span className="wdc-brand__mark" aria-hidden="true">
            W
          </span>
          <span className="wdc-brand__name">
            <strong>Windrop</strong> <span className="wd-muted">console</span>
          </span>
          <EnvBadge />
        </div>
        <h1 className="wd-display-sm">{title}</h1>
        {children}
      </div>
    </div>
  );
}
